import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import $ from "jquery";
import Server from '../../../functions/server';
import ReadCookie from '../../../functions/readcookies';
import Loading from '../../loadings';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class changeStatus extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    update: false,
    maxWidth: 'md',
    requestitems: []
  };

  openDialog() {
    if (this.props.menuPermission.edit) {
      if (this.props.customer == '' || this.props.customer == 0 || this.props.customer == undefined || this.props.customer == null) {
        alert('Select Customer!!!');
        return;
      }
      else {
        this.setState({ dialog: true })
      }
    }
    else {
      alert('You Are Not Allow to Generate Quotation')
    }
  }

  handleClose = () => {
    this.setState({ dialog: false })
  }

  submit() {
    let context = this;
    let orderData = this.props.data;
    let order = [];
    orderData.map((o) => {
      if (o.status == 'Approved' && o.customer_id == this.props.customer) {
        order.push({ id: o.id, mid: o.mid });
      }
    })
    if (order.length <= 0) {
      alert('No data is available!!!');
      return;
    }
    let cook = (ReadCookie("vaigai"));
    let id = cook.id;
    let delivery = 0;
    let customer = this.props.customer;
    order = JSON.stringify(order);
    this.setState({
      load: true,
      message: 'Update Quotation',
    })

    let data = (ReadCookie("branch"));
    let branch_id;
    for (var i = 0; i < data.length; i++) {
      branch_id = data[i].branch_id;
    }

    let url = Server() + 'orderstatus/generatequotation.php';
    $.ajax({
      type: 'POST',
      data: { 'orders': order, 'id': customer, 'created_by': id, 'delivery': delivery, 'branch_id': branch_id },
      url: url,
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false })
        if (data >= 1) {
          orderData.map((o) => {
            if (o.status == 'Approved' && o.customer_id == context.props.customer) {
              o.quotation_no = data;
              o.status = 'Pending For Delivery';
            }
          })
          context.props.seprateMaterDetails(orderData);
          context.props.updateData(orderData);
          context.setState({ dialog: false })
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        })
      }
    })
  }

  handleTextBox = name => event => {
    this.setState({ [name]: event.target.value })
  }

  render() {
    let i = 0;
    let j = 0;
    return (
      <div style={{color: '#4574A3'}}>
        <Button variant="outlined" color="primary" onClick={this.openDialog.bind(this)}>Generate Quotation</Button>
        <Loading load={this.state.load} message={this.state.message} />
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.dialog}
            onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Item(s)</DialogTitle>
            <DialogContent>
            <table width='100%' id='table'>
              <tr>
                <th id='th'><center>Sino</center></th>
                <th id='th'><center>Partno</center></th>
                <th id='th'><center>Spare Name</center></th>
                <th id='th'><center>Qty</center></th>
                <th id='th'><center>Status</center></th>
                <th id='th'><center>Total</center></th>
              </tr>
              { this.props.data.map((c) => {
                  if ((c.status == 'Approved') && c.customer_id == this.props.customer) {
                    j++;
                    return (
                      <tr>
                        <td><center>{j}</center></td>
                        <td>{c.partno}</td>
                        <td>{c.spare_name}</td>
                        <td><center>{c.qty}</center></td>
                        <td><center>{c.status}</center></td>
                        <td>{c.totprice}</td>
                      </tr>
                    )
                  }
                })
              }
            </table>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.submit.bind(this)}>Genarate Quotation</Button>
              <Button onClick={this.handleClose}>Close</Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

changeStatus.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(changeStatus);
